
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SpinnerToast extends Vue {
  visible = false;
  message = "";
  timeoutSeconds = 0;
  currentSeconds = 0;
  timeoutId: ReturnType<typeof setTimeout> | null = null;
  countdownInterval: ReturnType<typeof setInterval> | null = null;

  get progressPercentage(): number {
    if (this.timeoutSeconds > 0 && this.currentSeconds > 0) {
      return ((this.timeoutSeconds - this.currentSeconds) / this.timeoutSeconds) * 100;
    }
    return 0;
  }

  show(message: string, timeoutSeconds: number = 3): void {
    // Önceki timeout ve interval'leri temizle
    this.clearTimers();

    this.message = message;
    this.timeoutSeconds = timeoutSeconds;
    this.currentSeconds = timeoutSeconds;
    this.visible = true;

    // Belirtilen süre sonra gizle
    if (timeoutSeconds > 0) {
      // Geri sayım interval'i
      this.countdownInterval = setInterval(() => {
        this.currentSeconds--;
        if (this.currentSeconds <= 0) {
          this.clearTimers();
          this.hide();
        }
      }, 1000);

      // Timeout
      this.timeoutId = setTimeout(() => {
        this.clearTimers();
        this.hide();
      }, timeoutSeconds * 1000);
    }
  }

  hide(): void {
    this.visible = false;
    this.clearTimers();
  }

  clearTimers(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.currentSeconds = 0;
  }

  beforeDestroy(): void {
    this.clearTimers();
  }
}
